import React, { Component } from 'react'
import ReactModal from 'react-modal'
import classnames from 'classnames'

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: !!props.autoOpen }

    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
  }

  open() {
    this.setState({ isOpen: true })
  }

  close() {
    this.setState({ isOpen: false })
  }

  render() {
    const { children, className, closeButton, theme, ...rest } = this.props
    const { isOpen } = this.state
    const classes = classnames('modal', `modal--${theme}`, className)
    const overlayClasses = classnames(
      'modal__overlay', `modal__overlay--${theme}`
    )

    return (
      <ReactModal
        isOpen={isOpen}
        onRequestClose={this.close}
        overlayClassName={overlayClasses}
        className={classes}
        {...rest}
      >
        { closeButton ? (
            <a href="javascript:void(0)"
               className="modal__times"
               title={ I18n.t('browser_not_supported.close') }
               onClick={this.close}
            />
          ) : null
        }
        <div className="modal__content-wrapper">
          <div className="modal__inner-wrapper">
            { children }
          </div>
        </div>
      </ReactModal>
    )
  }
}

Modal.defaultProps = {
  autoOpen: false,
  closeButton: true,
  theme: 'white'
}

export default Modal
